import { Modal } from 'antd';
import { useState, useMemo, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';

interface ParcelOrderSecondoryPrintProps {
  visible: boolean;
  selected: any[];
  onClose: () => void;
}

const ParcelOrderSecondoryPrint = ({
  visible,
  onClose,
  selected,
}: ParcelOrderSecondoryPrintProps) => {
  const { parcelStatusCd } = useParams();
  const [printPdfLoading, setPrintPdfLoading] = useState(true);
  const location = useLocation();

  const printIframeUrl = useMemo(() => {
    const orderIds: number[] = [...new Set(selected.map((itm) => itm.no))];
    const url = `/api/order/print/secondory${location.search}&status=${parcelStatusCd}&lineItemNos=${orderIds}`;
    return url;
  }, [location, parcelStatusCd, selected]);

  const showPrintIframe = useCallback(() => {
    setPrintPdfLoading(false);
  }, []);
  return (
    <Modal title="Дагавар хэвлэх" onCancel={onClose} open={visible} footer={false}>
      <iframe
        width="100%"
        height={600}
        src={printIframeUrl}
        frameBorder={0}
        onLoad={showPrintIframe}
        style={{ visibility: printPdfLoading ? 'hidden' : 'visible' }}
      />
    </Modal>
  );
};

export default ParcelOrderSecondoryPrint;
